import script from "./editAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./editAccess.vue?vue&type=script&setup=true&lang=js"

import "./editAccess.vue?vue&type=style&index=0&id=00643d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00643d9a"]])

export default __exports__